<maximizer-outlook-notification #notification [closable]="true">
</maximizer-outlook-notification>

<div class="flex h-full min-h-0 flex-col">
  @if (currentPage() === 'summary' || currentPage() === 'chat') {
    <maximizer-outlook-tab-switcher
      [tabs]="tabs"
      [activeInput]="currentPage()"
      (tabChange)="handleTabChange($event)"
    ></maximizer-outlook-tab-switcher>
  }
  <div class="flex min-h-0 flex-1 flex-col gap-2">
    <maximizer-outlook-iq-boost-entry-context
      class="px-3 pt-3"
    ></maximizer-outlook-iq-boost-entry-context>
    @if (promptsLoading()) {
      <maximizer-outlook-iq-boost-skeleton
        class="px-3"
      ></maximizer-outlook-iq-boost-skeleton>
    } @else if (currentPage() === 'main') {
      <p class="p-2 text-body text-neutral-70 px-3">
        {{ 'outlook.iqBoost.selectQuestion' | translate }}
      </p>
      <p class="text-body text-neutral-90 px-3">
        <span class="fa-icons icon-book-sparkles icon-14 mr-2"></span
        >{{ 'outlook.iqBoost.suggestedQuestions' | translate }}
      </p>
      <div
        class="scrollbar overflow-y-auto flex-1 min-h-0 flex flex-col gap-2 px-3 pb-2"
      >
        @for (item of mainPagePrompts(); track $index) {
          <button class="question" (click)="handlePredefinedPromptClick(item)">
            <p class="text-body large text-neutral-90">
              {{ item.title }}
            </p>
            <span
              class="fa-icons icon-14 icon-chevron-right text-neutral-70"
            ></span>
          </button>
        }
        <div class="flex justify-end">
          <button
            kendoButton
            themeColor="tertiary"
            class="text-body bold"
            (click)="openQuestionLibrary()"
          >
            {{ 'outlook.buttons.showMore' | translate }}
          </button>
        </div>

        @if (recentPrompts().length > 0) {
          <p class="text-body text-neutral-90 mt-2">
            {{ 'outlook.iqBoost.recentQuestions' | translate }}
          </p>
          @for (prompt of recentPrompts(); track $index) {
            <button class="question" (click)="handlePromptSubmit(prompt)">
              <p class="text-body large text-neutral-90">{{ prompt }}</p>
              <span
                class="fa-icons icon-14 icon-chevron-right text-neutral-70"
              ></span>
            </button>
          }
        }
      </div>
    } @else if (currentPage() === 'chat') {
      <maximizer-outlook-iq-boost-chat
        class="grow"
      ></maximizer-outlook-iq-boost-chat>
    } @else if (currentPage() === 'summary') {
      <maximizer-outlook-iq-boost-summary
        class="grow"
        (openLibrary)="openQuestionLibrary()"
      ></maximizer-outlook-iq-boost-summary>
    }
  </div>

  @if (currentPage() === 'main' || currentPage() === 'chat') {
    <div class="shrink-0">
      <maximizer-outlook-iq-boost-prompt-input
        (promptSubmit)="handlePromptSubmit($event)"
      ></maximizer-outlook-iq-boost-prompt-input>
    </div>
  }

  @if (currentPage() === 'summary' || currentPage() === 'chat') {
    <div class="shrink-0">
      <maximizer-outlook-ai-response-actions
        [showSaveNote]="currentPage() === 'summary'"
        [saveNoteDisabled]="saveNoteDisabled()"
        [feedBackDisabled]="!copyContent() || loading()"
        [feedbackGiven]="feedbackGiven()"
        [copyDisabled]="loading()"
        [copyContent]="copyContent()"
        [copySuccessKey]="copySuccessKey()"
        [feature]="iqBoostFeature()"
        [showCreateEmail]="showCreateEmail()"
        [createEmailDisabled]="createEmailDisabled()"
        [isComposeMode]="isComposeMode"
        (feedbackVoted)="onFeedbackVoted()"
        (saveNote)="onSaveNote()"
        (createEmail)="onCreateEmail()"
      ></maximizer-outlook-ai-response-actions>
    </div>
  }
</div>

@if (showQuestionLibrary()) {
  <maximizer-outlook-iq-boost-question-library
    (promptSelected)="handleLibraryPromptSelected($event)"
    (closeDialog)="this.showQuestionLibrary.set(false)"
  ></maximizer-outlook-iq-boost-question-library>
}

@if (showPrivacySecurityDialog()) {
  <maximizer-outlook-iq-boost-privacy-security
    [anonymizerStatus]="privacyService.anonymizerStatus()"
    [dataSource]="privacyService.dialogDataSource()"
    [serverRegion]="privacyService.dialogServerRegion()"
    [anonymizerEnabled]="privacyService.anonymizerEnabled()"
    [dataSourceEnabled]="privacyService.dataSourceEnabled()"
    [serverRegionEnabled]="privacyService.serverRegionEnabled()"
    (closeDialog)="onPrivacySecurityClose()"
  ></maximizer-outlook-iq-boost-privacy-security>
}

@if (showSaveNoteDialog()) {
  <kendo-dialog width="95%" maxWidth="300px" (close)="confirmSaveNote(false)">
    <div
      class="reset flex items-center justify-between bg-neutral-10 px-2 py-1"
    >
      <p class="subtitle-1 text-black">
        {{ 'outlook.iqBoost.saveNoteDialog.title' | translate }}
      </p>
      <button
        kendoButton
        themeColor="tertiary"
        iconClass="fa-icons icon-xmark icon-14"
        [attr.aria-label]="'outlook.buttons.close' | translate"
        class="small"
        (click)="confirmSaveNote(false)"
      ></button>
    </div>
    <div class="flex flex-col gap-4 p-4">
      <p class="text-body large text-neutral-90">
        {{ 'outlook.iqBoost.saveNoteDialog.message' | translate }}
      </p>
      <div class="flex justify-end gap-2">
        <button
          kendoButton
          themeColor="secondary"
          (click)="confirmSaveNote(false)"
        >
          {{ 'outlook.buttons.cancel' | translate | uppercase }}
        </button>
        <button
          kendoButton
          themeColor="primary"
          (click)="confirmSaveNote(true)"
        >
          {{ 'outlook.buttons.ok' | translate | uppercase }}
        </button>
      </div>
    </div>
  </kendo-dialog>
}

@if (crmPrefillService.confirmCreateCRMAction()?.openDialog) {
  @let action = crmPrefillService.confirmCreateCRMAction();
  @let isEmbeddedForm =
    action?.action === MenuOptionName.AddNote ||
    action?.action === MenuOptionName.ScheduleToDo ||
    action?.action === MenuOptionName.ScheduleMeeting;
  <kendo-dialog
    [width]="isEmbeddedForm ? '100%' : '95%'"
    [height]="isEmbeddedForm ? '100%' : 'auto'"
    [maxWidth]="isEmbeddedForm ? 9999 : 300"
    (close)="cancelCRMAction()"
  >
    <div
      class="reset flex items-center justify-between bg-neutral-10 px-2 py-1"
    >
      <p class="subtitle-1 text-black">
        {{ action?.displayText }}
      </p>
      <button
        kendoButton
        themeColor="tertiary"
        iconClass="fa-icons icon-xmark icon-14"
        [attr.aria-label]="'outlook.buttons.close' | translate"
        class="small"
        [disabled]="savingCRMAction()"
        (click)="cancelCRMAction()"
      ></button>
    </div>
    @switch (action?.action) {
      @case (MenuOptionName.AddNote) {
        <maximizer-add-note
          class="iqboost-embedded-form flex flex-col flex-1 min-h-0"
          [embedded]="true"
          [type]="crmPrefillService.embeddedEntryType()"
          [id]="crmPrefillService.embeddedEntryId()"
          [prefill]="crmPrefillService.notePrefill()"
          (saved)="onEmbeddedCRMActionSaved(MenuOptionName.AddNote)"
          (cancelled)="onEmbeddedCRMActionCancelled()"
        ></maximizer-add-note>
      }
      @case (MenuOptionName.ScheduleToDo) {
        <maximizer-add-task
          class="iqboost-embedded-form flex flex-col flex-1 min-h-0"
          [embedded]="true"
          [type]="crmPrefillService.embeddedEntryType()"
          [id]="crmPrefillService.embeddedEntryId()"
          [prefill]="crmPrefillService.taskPrefill()"
          (saved)="onEmbeddedCRMActionSaved(MenuOptionName.ScheduleToDo)"
          (cancelled)="onEmbeddedCRMActionCancelled()"
        ></maximizer-add-task>
      }
      @case (MenuOptionName.ScheduleMeeting) {
        <maximizer-add-appointment
          class="iqboost-embedded-form flex flex-col flex-1 min-h-0"
          [embedded]="true"
          [type]="crmPrefillService.embeddedEntryType()"
          [id]="crmPrefillService.embeddedEntryId()"
          [prefill]="crmPrefillService.appointmentPrefill()"
          (saved)="onEmbeddedCRMActionSaved(MenuOptionName.ScheduleMeeting)"
          (partiallySaved)="onEmbeddedAppointmentPartiallySaved($event)"
          (savingChange)="onEmbeddedCRMActionSavingChange($event)"
          (cancelled)="onEmbeddedCRMActionCancelled()"
        ></maximizer-add-appointment>
      }
      @default {
        <div class="flex flex-col gap-3 p-4">
          @if (crmPrefillService.confirmCreateCRMActionForLoading()) {
            <kendo-loader type="pulsing" size="small"></kendo-loader>
          } @else if (crmPrefillService.confirmCreateCRMActionFor()) {
            <p class="text-caption text-neutral-70">
              {{ crmPrefillService.confirmCreateCRMActionFor() }}
            </p>
          }
          @if (action?.title) {
            <p class="text-body large text-neutral-90">
              {{ action?.title }}
            </p>
          }
          @if (action?.description) {
            <p class="text-body-2 text-neutral-70">
              {{ action?.description }}
            </p>
          }
          @if (action?.date) {
            <p class="text-body-2 text-neutral-70">
              {{ action?.date }}
            </p>
          }
          <div class="flex justify-end gap-2">
            <button
              kendoButton
              themeColor="secondary"
              (click)="cancelCRMAction()"
            >
              {{ 'outlook.buttons.cancel' | translate | uppercase }}
            </button>
            <button
              kendoButton
              themeColor="primary"
              (click)="createCRMAction()"
            >
              {{ 'outlook.buttons.ok' | translate | uppercase }}
            </button>
          </div>
        </div>
      }
    }
  </kendo-dialog>
}
